import React from 'react';
import useGlobalConfig from 'helpers/useGlobalConfig';

// Components
import AddAttribute from './AddAttribute';

interface Props {
  categoryId?: string;
  onChange: (value: any) => void;
}

function Container(props: Props) {
  const globalConfig = useGlobalConfig();

  return <AddAttribute globalConfig={globalConfig} {...props} />;
}

export default Container;
